import Vue from "vue";
import commons from "./commons";
import formDesign from "./formDesign";

/* information system default */
const informationSystemDefault = [
	{
		id: "id",
		displayName: "ID",
		type: 37,
		description: "Auto-generated unique ID",
		system: true
	},
	{
		id: "documentId",
		displayName: "Document ID",
		type: 0,
		description: "Auto-generated unique document ID combination of prefix and serial number. eg. INV00245. Click to change the format, or to reset serial number",
		system: true
	},
	{
		id: "title",
		displayName: "Title",
		type: 0,
		description: "Auto-generated unique title/subject for an entry. Click to change the format",
		system: true
	},
	{
		id: "createdBy",
		displayName: "Created By",
		type: 19,
		description: "Users who created an entry",
		system: true
	},
	{
		id: "date",
		displayName: "Created Date",
		type: 5,
		description: "Date and time when an entry is created",
		system: true
	},
	{
		id: "lastChangeBy",
		displayName: "Last Change By",
		type: 19,
		description: "Users who did the last changed of an entry",
		system: true
	},
	{
		id: "lastChangeDate",
		displayName: "Last Change Date",
		type: 5,
		description: "Date and time of an entry last changed",
		system: true
	},
	{
		id: "serial",
		displayName: "Serial",
		type: 0,
		description: "Serial of an entry",
		system: true
	},
	{
		id: "state",
		displayName: "State",
		type: 0,
		description: "Progress of an entry",
		system: true
	},
	{
		id: "commentCount",
		displayName: "Comment Count",
		type: 2,
		description: "Total comment of an entry",
		system: true
	},
	{
		id: "assignees",
		displayName: "Assignees",
		type: 19,
		description: "Assignees of an entry",
		system: true
	},
	{
		id: "due",
		displayName: "Due",
		type: 6,
		description: "Due date of an entry",
		system: true,
	},
	{
		id: "username",
		displayName: "Username",
		type: 19,
		description: "Username of user who uses this entry as profile",
		system: true,
		userCollection: true,
	}
];

const information = {
	name: "information",
	fieldName: "information",
	displayName: "Information",
};

const activity = {
	name: "activity",
	fieldName: "activities",
	displayName: "Activity",
};

const standard = {
	name: "standardActivity",
	fieldName: "standardActivities",
	displayName: "Standard",
};

const state = {
	name: "state",
	fieldName: "states",
	displayName: "State",
};

const flow = {
	name: "flow",
	fieldName: "flows",
	displayName: "Flow",
};

const menu = {
	name: "menu",
	fieldName: "menus",
	displayName: "Listing",
};

const document = {
	name: "document",
	fieldName: "documents",
	displayName: "Template",
};

const action = {
	name: "action",
	fieldName: "actions",
	displayName: "Custom",
};

const logic = {
	name: "logicService",
	fieldName: "logicServices",
	displayName: "Logic",
};

/* canvas */
/* duplicate code from canvasDesignStore.js / actions / loadVector() */
/**
 * canvas:initial
 * @param {Object} canvas 
 */
const initCanvas = (canvas) => {
	if (canvas.standardActivities == null) {
		canvas.standardActivities = commons.standards;
	} else {
		let standardActivities = canvas.standardActivities;
		Vue.set(canvas, 'standardActivities', []);
		commons.standards.forEach(standard => {
			let found = standardActivities.find(x => x.id == standard.id);
			if (found) {
				standardActivities = standardActivities.filter(item => item !== found);
				canvas.standardActivities.push(found);
			} else {
				canvas.standardActivities.push(standard);
			}
		});

		standardActivities.forEach(x => {
			if (
				canvas.triggers &&
				canvas.triggers.find(y => y.item == x.id)
			) {
				canvas.standardActivities.push(x);
			}
		});
	}

	if (canvas.connector) {
		canvas.connectorText = JSON.stringify(canvas.connector);
		delete canvas.connector;
	}

	if (canvas.mapping) {
		canvas.mappingText = JSON.stringify(canvas.mapping);
		delete canvas.mapping;
	}
}
/**
 * 
 * @param {Array} triggers 
 * @param {string} item 
 * @param {string} type 
 * @returns {Array} 
 */
const deleteDependentTriggers = (triggers, item, type) => {
	return triggers.filter(x => !(x.item === item && x.type === type));
}
/**
 * 
 * @param {Array} authorizations 
 * @param {string} unitId 
 * @param {?string} type 
 * @returns {Array} 
 */
const deleteDependentAuthorizations = (authorizations, unitId, type) => {
	return authorizations.filter(x => {
		return type
			? !(x.authorizationUnitId === unitId && x.authorizationType === type)
			: x.authorizationUnitId !== unitId;
	});
}
/**
 * information:initial
 * @param {Object} item 
 * @returns 
 */
const initInformation = (item) => {
	let selected = { ...item };

	if (!selected.id) {
		selected.id = commons.generateFieldName();
		selected.fieldName = commons.generateFieldName();
	}

	return selected;
};
/**
 * information:set
 * @param {Object} canvas 
 * @param {Object} item 
 * @param {string|null} parentId 
 */
const setInformation = (canvas, item, parentId) => {
	if (!commons.isArray(canvas[information.fieldName])) {
		canvas[information.fieldName] = [];
	}
	if (parentId) {
		let parent = _.findDeep(canvas[information.fieldName], (x) => x.id == parentId, {
			childrenPath: "fields",
		});
		if (parent && parent.value) {
			if (!commons.isArray(parent.value.fields)) {
				Vue.set(parent.value, "fields", [item]);
			} else {
				const findIndex = parent.value.fields.findIndex((x) => x.id === item.id);
				if (findIndex > -1) {
					Vue.set(parent.value.fields, findIndex, item);
				} else {
					parent.value.fields.push(item);
				}
			}
		} else {
			console.error('unable setInformation() due to parent is not exist.');
		}
	} else {
		const findIndex = canvas[information.fieldName].findIndex((x) => x.id == item.id);
		if (findIndex > -1) {
			Vue.set(canvas[information.fieldName], findIndex, item);
		} else {
			let findDeep = _.findDeep(canvas[information.fieldName], x => x.id == item.id, {
				childrenPath: "fields",
			});
			if (findDeep && findDeep.parent && findDeep.key) {
				Vue.set(findDeep.parent.fields, findDeep.key, item);
			} else {
				canvas[information.fieldName].push(item);
			}
		}
	}
};
/**
 * information:delete
 * @param {Object} canvas 
 * @param {string} id 
 */
const deleteInformation = (canvas, id) => {
	let res = _.findDeep(canvas[information.fieldName], (x) => x.id == id, {
		childrenPath: 'fields'
	});
	if (res && res.value && res.key > -1) {
		if (typeof res.parent === 'object' && Array.isArray(res.parent.fields)) {
			res.parent.fields.splice(res.key, 1);
		} else {
			canvas[information.fieldName].splice(res.key, 1);

			if (canvas.triggers && canvas.triggers.length) {
				canvas.triggers = deleteDependentTriggers(canvas.triggers, id, "information");
			}
		}
	}
};
/**
 * information:get
 * @param {Object} canvas 
 * @param {string} id 
 * @returns 
 */
const getInformation = (canvas, id) => {
	const res = _.findDeep(canvas[information.fieldName], (x) => x.id == id, {
		childrenPath: 'fields'
	});
	return res && res.value;
}
/**
 * 
 * @param {Array} list 
 * @param {string} id 
 * @returns 
 */
const findInformation = (list, id) => {
	if (!Array.isArray(list)) return null;

	for (const item of list) {
		if (item.id === id) {
			return item;
		}

		if (item.fields && item.fields.length) {
			const found = findInformation(item.fields, id);
			if (found) return found;
		}
	}

	return null;
}
/**
 * activity:initial
 * @param {Object} item 
 * @returns 
 */
const initActivity = (item) => {
	let selected = { ...item };

	if (!selected.id) {
		selected.id = commons.newUUID();
	}

	return selected;
};
/**
 * activity:set
 * @param {Object} canvas 
 * @param {Object} item 
 */
const setActivity = (canvas, item) => {
	if (!commons.isArray(canvas[activity.fieldName])) {
		canvas[activity.fieldName] = [];
	}

	const findIndex = canvas[activity.fieldName].findIndex((x) => x.id == item.id);
	if (findIndex > -1) {
		Vue.set(canvas[activity.fieldName], findIndex, item);
	} else {
		canvas[activity.fieldName].push(item);
	}
};
/**
 * activity:get
 * @param {Object} canvas 
 * @param {string} id 
 * @returns 
 */
const getActivity = (canvas, id) => {
	return canvas[activity.fieldName].find((x) => x.id === id);
}
/**
 * activity:delete
 * @param {Object} canvas 
 * @param {Object} item 
 * @param {string} item.id 
 */
const deleteActivity = (canvas, item) => {
	const findIndex = canvas[activity.fieldName].findIndex(x => x.id == item.id);
	if (findIndex > -1) {
		canvas[activity.fieldName].splice(findIndex, 1);
	}

	if (canvas.triggers && canvas.triggers.length) {
		canvas.triggers = deleteDependentTriggers(canvas.triggers, item.id, "activity");
	}

	if (canvas.authorizations && canvas.authorizations.length) {
		canvas.authorizations = deleteDependentAuthorizations(canvas.authorizations, item.id, "activity");
	}
};
/**
 * standard:set
 * @param {Object} canvas 
 * @param {Object} item 
 */
const setStandard = (canvas, item) => {
	if (!commons.isArray(canvas[standard.fieldName])) {
		canvas[standard.fieldName] = [];
	}

	const findIndex = canvas[standard.fieldName].findIndex((x) => x.id == item.id);
	if (findIndex > -1) {
		Vue.set(canvas[standard.fieldName], findIndex, item);
	} else {
		canvas[standard.fieldName].push(item);
	}
};
/**
 * state:initial
 * @param {Object} item 
 * @returns 
 */
const initState = (item) => {
	let selected = { ...item };

	if (!selected.id) {
		selected.id = commons.newUUID();
	}

	return selected;
};
/**
 * state:set
 * @param {Object} canvas 
 * @param {Object} item 
 */
const setState = (canvas, item) => {
	if (!commons.isArray(canvas[state.fieldName])) {
		canvas[state.fieldName] = [];
	}

	if (Boolean(item.initial)) {
		canvas[state.fieldName].forEach(x => {
			x.initial = null;
		});
		item.initial = true;
	}

	const findIndex = canvas[state.fieldName].findIndex((x) => x.id == item.id);
	if (findIndex > -1) {
		Vue.set(canvas[state.fieldName], findIndex, item);
	} else {
		canvas[state.fieldName].push(item);
	}
};
/**
 * state:get
 * @param {Object} canvas 
 * @param {string} id 
 * @returns 
 */
const getState = (canvas, id) => {
	return canvas[state.fieldName].find((x) => x.id === id);
}
/**
 * state:delete
 * @param {Object} canvas 
 * @param {Object} item 
 * @param {Object} item.id 
 */
const deleteState = (canvas, item) => {
	const findIndex = canvas[state.fieldName].findIndex(x => x.id == item.id);
	if (findIndex > -1) {
		canvas[state.fieldName].splice(findIndex, 1);
	}

	if (canvas.triggers && canvas.triggers.length) {
		canvas.triggers = deleteDependentTriggers(canvas.triggers, item.id, "state");
	}
};
/**
 * flow:initia;
 * @param {Object} item 
 * @returns 
 */
const initFlow = (item) => {
	let selected = { ...item };

	if (!selected.id) {
		selected.id = commons.newUUID();
	}

	return selected;
};
/**
 * flow:set
 * @param {Object} canvas 
 * @param {Object} item 
 */
const setFlow = (canvas, item) => {
	if (!commons.isArray(canvas[flow.fieldName])) {
		canvas[flow.fieldName] = [];
	}

	const findIndex = canvas[flow.fieldName].findIndex((x) => x.id == item.id);
	if (findIndex > -1) {
		Vue.set(canvas[flow.fieldName], findIndex, item);
	} else {
		canvas[flow.fieldName].push(item);
	}
};
/**
 * flow:delete
 * @param {Object} canvas 
 * @param {Object} item 
 */
const deleteFlow = (canvas, item) => {
	const findIndex = canvas[flow.fieldName].findIndex(x => x.id == item.id);
	if (findIndex > -1) {
		canvas[flow.fieldName].splice(findIndex, 1);
	}
};
/**
 * menu:initial
 * @param {Object} item 
 * @returns 
 */
const initMenu = (item) => {
	let selected = { ...item };

	if (!selected.id) {
		selected.id = commons.nanoID();
	}

	return selected;
};
/**
 * menu:set
 * @param {Object} canvas 
 * @param {Object} item 
 */
const setMenu = (canvas, item) => {
	if (!commons.isArray(canvas[menu.fieldName])) {
		canvas[menu.fieldName] = [];
	}

	const findIndex = canvas[menu.fieldName].findIndex((x) => x.id == item.id);
	if (findIndex > -1) {
		Vue.set(canvas[menu.fieldName], findIndex, item);
	} else {
		canvas[menu.fieldName].push(item);
	}
};
/**
 * state:get
 * @param {Object} canvas 
 * @param {string} id 
 * @returns 
 */
const getMenu = (canvas, id) => {
	return canvas[menu.fieldName].find((x) => x.id === id);
}
/**
 * The legacy "defaultListing" placeholder row: a design carrier three clients synthesised, never a
 * view. The server hides it from every listing surface and lifts its design into canvas.listDesign
 * on save (docs/listing-default-listing-design-carrier-proposal.md, R13); the client keeps the row
 * until the Phase 2 app is the floor (R9), so every design surface must skip it.
 * @param {Object} item
 * @returns {boolean}
 */
const isLegacyDefaultListing = (item) => !!item && item.id === 'defaultListing' && item.default === true;
/**
 * Real views only: the menus array without the legacy placeholder row.
 * @param {Array} menus
 * @returns {Array}
 */
const realMenus = (menus) => Array.isArray(menus) ? menus.filter((x) => !isLegacyDefaultListing(x)) : [];
/**
 * The module-level listing design (canvas.listDesign) as the design surfaces edit it: a listing-shaped
 * object carrying only design keys. Created empty when missing.
 * @param {Object} canvas
 * @returns {Object}
 */
const listDesignOf = (canvas) => {
	if (!canvas.listDesign || typeof canvas.listDesign !== 'object') canvas.listDesign = {};
	if (!canvas.listDesign.list || !Array.isArray(canvas.listDesign.list.columns)) canvas.listDesign.list = { columns: [] };
	return canvas.listDesign;
}
/**
 * menu:delete
 * @param {Object} canvas 
 * @param {Object} item 
 * @param {string} item.id 
 */
const deleteMenu = (canvas, item) => {
	const findIndex = canvas[menu.fieldName].findIndex(x => x.id == item.id);
	if (findIndex > -1) {
		canvas[menu.fieldName].splice(findIndex, 1);
	}

	if (canvas.authorizations && canvas.authorizations.length) {
		canvas.authorizations = deleteDependentAuthorizations(canvas.authorizations, item.id, "menu");
	}
};

const menuDesignPropDownValues = [
	'id', 'displayName', 'fieldName', 'type', 'description', 'fields', 
	'predefinedFormatId', 'customFormat', 'decimalPlaces',
	'formulaMode', 'formula', 'computed'
];
/**
 * 
 * @param {Object} column 
 * @param {Array} information 
 * @returns 
 */
const expandMenuDesignInternal = (column, information) => {
	const findInformation = information.find(x => x.id === column.id);
	if (findInformation && !column.system) {
		const informationItem = _.cloneDeep(findInformation);
		menuDesignPropDownValues.forEach(prop => {
			if (informationItem.hasOwnProperty(prop) || column.hasOwnProperty(prop)) {
				if (prop == 'fields' && (informationItem.type == 14 || informationItem.type == 15)) {
					if (!(informationItem.fields && informationItem.fields.length)) {
						column.fields = [];
					} else if (!(column.fields && column.fields.length)) {
						column.fields = informationItem.fields;
					} else {
						column.fields = column.fields.filter(x =>
							informationItem.fields.some((y) => y.id === x.id)
						);

						informationItem.fields
							.filter(x => !column.fields.some((y) => y.id === x.id))
							.forEach(x => {
								column.fields.splice(informationItem.fields.findIndex(y => y.id === x.id), 0, x);
							});
					}

					column.fields.forEach(field => {
						expandMenuDesignInternal(field, informationItem.fields);
					});
				} else {
					column[prop] = informationItem[prop];
				}
			}
		});

		return column;
	}
}
/**
 * 
 * @param {Array} columns 
 * @param {Array} information 
 */
const expandMenuDesign = (columns, information) => {
	if (Array.isArray(columns) && Array.isArray(information)) {
		columns.forEach(column => {
			expandMenuDesignInternal(column, information);
		});
	}
}
/**
 * 
 * @param {Array} menus 
 * @param {Array} information 
 */
const expandMenusDesign = (menus, information) => {
	if (Array.isArray(menus) && Array.isArray(information)) {
		menus.forEach(menu => {
			if (menu.list && Array.isArray(menu.list.columns)) {
				expandMenuDesign(menu.list.columns, information);
			}

			if (menu.mobileListDesign && Array.isArray(menu.mobileListDesign.columns)) {
				expandMenuDesign(menu.mobileListDesign.columns, information);
			}
		});
	}
}

const menuDesignToKeepValues = [
	// information
	'id', 'fields', 'formulaMode', 'formula', 'computed',
	// workaround for export
	'type', 'fieldName', 'displayName', 'predefinedFormatId', 'customFormat', 'decimalPlaces',
	// column design
	'label', 'width', 'wrap', 'hide'
];
/**
 * 
 * @param {Object} column 
 * @param {Array} information 
 */
const compactMenuDesignInternal = (column, information) => {
	const findInformation = information.find(x => x.id === column.id);
	if (findInformation && !column.system) {
		const informationItem = _.cloneDeep(findInformation);

		if (informationItem.type == 14 || informationItem == 15) {
			if (!(informationItem.fields && informationItem.fields.length)) {
				column.fields = [];
			} else if (!(column.fields && column.fields.length)) {
				column.fields = informationItem.fields;
			} else {
				column.fields = column.fields.filter(x =>
					informationItem.fields.some((y) => y.id === x.id)
				);

				informationItem.fields
					.filter(x => !column.fields.some((y) => y.id === x.id))
					.forEach(x => {
						column.fields.splice(informationItem.fields.findIndex(y => y.id === x.id), 0, x);
					});
			}

			column.fields.forEach(field => {
				compactMenuDesignInternal(field, informationItem.fields);
			});
		}

		if (informationItem.hasOwnProperty('formulaMode')) {
			column.formulaMode = informationItem.formulaMode;
		} else if (column.hasOwnProperty('formulaMode')) {
			delete column.formulaMode;
		}

		if (informationItem.hasOwnProperty('computed')) {
			column.computed = informationItem.computed;
		} else if (column.hasOwnProperty('computed')) {
			delete column.computed;
		}

		if (informationItem.hasOwnProperty('formula')) {
			column.formulaMode = informationItem.formulaMode;
		} else if (column.hasOwnProperty('formula')) {
			delete column.formulaMode;
		}

		for (var key in column) {
			if (!menuDesignToKeepValues.some(x => x== key)) {
				delete column[key];
			}
		}
	}
}
/**
 * 
 * @param {Array} columns 
 * @param {Array} information 
 */
const compactMenuDesign = (columns, information) => {
	if (Array.isArray(columns) && Array.isArray(information)) {
		columns.forEach(column => {
			compactMenuDesignInternal(column, information);
		});
	}
}
/**
 * 
 * @param {Array} menus 
 * @param {Array} information 
 */
const compactMenusDesign = (menus, information) => {
	if (Array.isArray(menus) && Array.isArray(information)) {
		menus.forEach(menu => {
			if (menu.list && Array.isArray(menu.list.columns)) {
				compactMenuDesign(menu.list.columns, information);
			}

			if (menu.mobileListDesign && Array.isArray(menu.mobileListDesign.columns)) {
				compactMenuDesign(menu.mobileListDesign.columns, information);
			}
		});
	}
}
/**
 * document:initial
 * @param {Object} item 
 * @returns 
 */
const initDocument = (item) => {
	let selected = { ...item };

	if (!selected.id) {
		selected.id = commons.newUUID();
		selected.version = 1.0;
	}

	return selected;
};
/**
 * document:set
 * @param {Object} canvas 
 * @param {Object} item 
 */
const setDocument = (canvas, item) => {
	if (!commons.isArray(canvas[document.fieldName])) {
		canvas[document.fieldName] = [];
	}

	const findIndex = canvas[document.fieldName].findIndex((x) => x.id == item.id);
	if (findIndex > -1) {
		Vue.set(canvas[document.fieldName], findIndex, item);
	} else {
		canvas[document.fieldName].push(item);
	}
};
/**
 * document:delete
 * @param {Object} canvas 
 * @param {Object} item 
 * @param {Object} item.id 
 */
const deleteDocument = (canvas, item) => {
	const findIndex = canvas[document.fieldName].findIndex(x => x.id == item.id);
	if (findIndex > -1) {
		canvas[document.fieldName].splice(findIndex, 1);
	}

	if (canvas.authorizations && canvas.authorizations.length) {
		canvas.authorizations = deleteDependentAuthorizations(canvas.authorizations, item.id)
	}
};
/* form design */
const documentFormDesignPropDowns = [
	'type', 'fieldName', 'displayName',
	'customFormat', 'decimalPlaces',
	'predefinedFormatId', 'optionList'
];
/**
 * 
 * @param {Object} item 
 * @param {Array} information 
 * @returns 
 */
const expandDocumentFormDesignInternal = (item, information) => {
	if (item.input === 'section') {
		if (item.type === 'tab') {
			delete item['design'];
			if (Array.isArray(item.tabs)) {
				item.tabs.forEach((x) => {
					expandDocumentFormDesign(x.design, information);
				});
			}
		} else {
			delete item['tabs'];
			if (item.design !== null) {
				expandDocumentFormDesign(item.design, information);
			}
		}
	} else if (
		item.id &&
		(!item.input || !formDesign.isElement(item.input))
	) {
		const findInformation = information.find((x) => x.id === item.id);
		if (findInformation) {
			const informationItem = _.cloneDeep(findInformation);
			if (informationItem.type == 14) {
				if (!(informationItem.fields && informationItem.fields.length)) {
					item.fields = [];
				} else if (!(item.fields && item.fields.length)) {
					item.fields = [...informationItem.fields];
				} else {
					/* remove fields */
					item.fields = item.fields
						.filter((x) => informationItem.fields.some((y) => y.id === x.id))
						.map((x) => expandDocumentFormDesignInternal(x, informationItem.fields));
					/* add fields */
					informationItem.fields
						.filter((x) => !item.fields.some((y) => y.id === x.id))
						.forEach((x) => {
							item.fields.splice(informationItem.fields.findIndex((y) => y.id === x.id), 0, x)
						});
				}
			}

			documentFormDesignPropDowns.forEach((x) => {
				if (informationItem.hasOwnProperty(x) || item.hasOwnProperty(x)) {
					item[x] = informationItem[x];
				}
			});
		}
	}
	return item;
}
/**
 * 
 * @param {Object} design 
 * @param {Array} information 
 */
const expandDocumentFormDesign = (design, information) => {
	if (design && Array.isArray(design.rows) && Array.isArray(information)) {
		design.rows.forEach((x) => {
			if (x.items != null) {
				x.items = x.items.map((y) => expandDocumentFormDesignInternal(y, information))
			}
		});
	}
}
/**
 * 
 * @param {Object} canvas 
 */
const expandDocumentsFormDesign = (canvas) => {
	if (Array.isArray(canvas[document.fieldName]) && Array.isArray(canvas[information.fieldName])) {
		canvas[document.fieldName].forEach((x) => {
			x.design && expandDocumentFormDesign(x.design, canvas[information.fieldName]);
			x.userInput && expandDocumentFormDesign(x.userInput, canvas[information.fieldName]);
		});
	}
}
/**
 * action:initial
 * @param {Object} item 
 * @returns 
 */
const initAction = (item) => {
	let selected = { ...item };

	if (!selected.id) {
		selected.id = commons.newUUID();
	}

	return selected;
};
/**
 * action:set
 * @param {Object} canvas 
 * @param {Object} item 
 */
const setAction = (canvas, item) => {
	if (!commons.isArray(canvas[action.fieldName])) {
		canvas[action.fieldName] = [];
	}

	const findIndex = canvas[action.fieldName].findIndex((x) => x.id == item.id);
	if (findIndex > -1) {
		Vue.set(canvas[action.fieldName], findIndex, item);
	} else {
		canvas[action.fieldName].push(item);
	}
};
/**
 * action:delete
 * @param {Object} canvas 
 * @param {Object} item 
 * @param {string} item.id 
 */
const deleteAction = (canvas, item) => {
	const findIndex = canvas[action.fieldName].findIndex(x => x.id == item.id);
	if (findIndex > -1) {
		canvas[action.fieldName].splice(findIndex, 1);
	}

	if (canvas.authorizations && canvas.authorizations.length) {
		canvas.authorizations = deleteDependentAuthorizations(canvas.authorizations, item.id);
	}
};
/**
 * logic:init
 * @param {Object} item 
 * @returns 
 */
const initLogic = (item) => {
	let selected = { ...item };

	if (!selected.id) {
		selected.id = commons.newUUID();
	}

	return selected;
};
/**
 * logic:set
 * @param {Object} canvas 
 * @param {Object} item 
 * @param {string} item.id 
 */
const setLogic = (canvas, item) => {
	if (!commons.isArray(canvas[logic.fieldName])) {
		canvas[logic.fieldName] = [];
	}

	const findIndex = canvas[logic.fieldName].findIndex((x) => x.id == item.id);
	if (findIndex > -1) {
		Vue.set(canvas[logic.fieldName], findIndex, item);
	} else {
		canvas[logic.fieldName].push(item);
	}
};
/**
 * logic:delete
 * @param {Object} canvas 
 * @param {Object} item
 * @param {string} item.id 
 */
const deleteLogic = (canvas, item) => {
	const findIndex = canvas[logic.fieldName].findIndex(x => x.id == item.id);
	if (findIndex > -1) {
		canvas[logic.fieldName].splice(findIndex, 1);
	}
};
/**
 * trigger:initial
 * @param {Object} item 
 * @returns 
 */
const initTrigger = (item) => {
	let selected = {
		...item
	}

	if (!selected.id) {
		selected.id = commons.newUUID();
	}

	return selected;
}
/**
 * 
 * @param {Object} canvas 
 */
const compactDesignBeforeSave = (canvas) => {
	if (canvas.connectorText != '' && canvas.connectorText != null) {
		canvas.connector = JSON.parse(canvas.connectorText);
		delete canvas.connectorText;
	}
	if (canvas.mappingText != '' && canvas.mappingText != null) {
		canvas.mapping = JSON.parse(canvas.mappingText);
		delete canvas.mappingText;
	}
	try {
		expandDocumentsFormDesign(canvas);
	} catch(error) {
		console.error(err);
	}
}

export default {
	informationSystemDefault: informationSystemDefault,
	information: information,
	activity: activity,
	standard: standard,
	state: state,
	flow: flow,
	menu: menu,
	document: document,
	action: action,
	logic: logic,
	initCanvas: initCanvas,
	initInformation: initInformation,
	initActivity: initActivity,
	initState: initState,
	initFlow: initFlow,
	initMenu: initMenu,
	initDocument: initDocument,
	initAction: initAction,
	initLogic: initLogic,
	setInformation: setInformation,
	getInformation: getInformation,
	findInformation: findInformation,
	setActivity: setActivity,
	getActivity: getActivity,
	setStandard: setStandard,
	setState: setState,
	getState: getState,
	setFlow: setFlow,
	setMenu: setMenu,
	getMenu: getMenu,
	isLegacyDefaultListing: isLegacyDefaultListing,
	realMenus: realMenus,
	listDesignOf: listDesignOf,
	setDocument: setDocument,
	setAction: setAction,
	setLogic: setLogic,
	deleteInformation: deleteInformation,
	deleteActivity: deleteActivity,
	deleteState: deleteState,
	deleteFlow: deleteFlow,
	deleteMenu: deleteMenu,
	expandMenuDesign: expandMenuDesign,
	expandMenusDesign: expandMenusDesign,
	compactMenusDesign: compactMenusDesign,
	deleteDocument: deleteDocument,
	expandDocumentFormDesign: expandDocumentFormDesign,
	expandDocumentsFormDesign: expandDocumentsFormDesign,
	deleteAction: deleteAction,
	deleteLogic: deleteLogic,
	initTrigger: initTrigger,
	compactDesignBeforeSave: compactDesignBeforeSave
}